import { getTestId } from '@airtel/air-design-system';
var additionalBenefits = [{
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}, {
  benefitUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg',
  benefitText: 'OTT'
}];
export var defaultProps = Object.assign({
  rowButtonsWidgetProps: Object.assign({
    direction: 'row',
    leftCta: {
      title: 'Email Bill',
      buttonType: 'secondary'
    },
    rightCta: {
      title: 'Primary',
      buttonType: 'primary'
    },
    onLeftCtaPress: {
      id: 'left-cta'
    },
    onRightCtaPress: {
      id: 'right-cta'
    }
  }, getTestId('ButtonWidgetContainer')),
  detailsDataCardList: [{
    wrapperStyle: {
      justifyContent: 'flex-start'
    },
    titleText: 'TITLE TEXT',
    subtitleText: 'Product name here',
    descriptionText: 'Description text comes here',
    showKeyBenefitsSection: true,
    footerText: 'Key benefits',
    infoIconProps: {
      showIcon: true
    },
    rightChevronProps: {
      showIcon: true
    },
    detailsData: [{
      key: 'Bill Cycle',
      value: '24th Aug - 23rd Sept',
      showKey: true,
      ctaProps: {
        title: 'Tert Button',
        style: {
          marginTop: 4
        },
        buttonType: 'tertiary'
      }
    }, {
      key: 'Due Date',
      value: '12th Dec 2023',
      showKey: true
    }, {
      key: 'Rental',
      value: '6 months'
    }, {
      key: 'Renewal Date',
      value: '12th Dec 2023'
    }],
    numberOfColumns: 2,
    infoTagHeaderProps: {
      subType: 'default',
      text: 'Text Label',
      iconName: 'AddEnclosedIcon',
      iconPosition: 'left'
    },
    infoTagSubHeaderProps: {
      subType: 'default',
      text: 'Text Label',
      iconName: 'AddEnclosedIcon',
      iconPosition: 'left'
    },
    tertiaryCTAProps: {
      title: 'TERTIARY CTA',
      buttonType: 'tertiary',
      version: 'variable-width',
      onLeftCtaPress: {
        id: 'tertiary-cta'
      }
    },
    viewDetailsCTAProps: {
      title: 'VIEW DETAILS',
      buttonType: 'tertiary',
      version: 'variable-width',
      onLeftCtaPress: {
        id: 'view-details'
      }
    },
    additionalBenefits: additionalBenefits,
    calloutWidgetProps: {
      title: '',
      description: 'after 17 oct you will be charged ₹100 as late fee, payable ₹1,278.00 ',
      iconName: 'AlertMediumButtonIcon',
      state: 'warning'
    }
  }]
}, getTestId('InfoSummaryWidgetContainer'));